import Button from "../Button";
import {FaSms} from "react-icons/fa";
import {useState, useRef, useEffect} from "react";
import {persianToEnglish} from "../../tools/helpers";
import useTimer from "../../hooks/useTimer";
import {AiOutlineArrowRight} from "react-icons/ai";

const OTP = (
    {
        confirmLoading,
        retryLoading,
        error,
        title = 'کد اعتبار سنجی',
        description = '',
        length = 5,
        handleRequestOTP = () => {
        },
        timerCount=120,
        hasBack=false,
        onBack=()=>{},
        handleConfirm = () => {
        }
    }
) => {

    const {time,resetTimer,isComplete}=useTimer(timerCount);
    const [inputValues, setInputValues] = useState(Array(length).fill('')); // Initialize state for input values
    const [disabled, setDisabled] = useState(true)
    const inputRefs = useRef([]);
    useEffect(() => {
        if (inputValues.join('').length < length) {
            setDisabled(true)
        } else {
            setDisabled(false)
        }

    }, [inputValues]);

    const handleChange = (index, event) => {
        const newValues = [...inputValues];
        const value = persianToEnglish(event.target.value.replace(/[^0-9\u06F0-\u06F9]/g, ''));
        newValues[index] = value;
        setInputValues(newValues);
        if (value.length === 1 && index < length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };
    const handleKeyDown = (index, event) => {
        if (event.key === 'Backspace' && inputValues[index] === '' && index > 0) {
            inputRefs.current[index - 1].focus(); // Move to the previous input
        }
    };
    const handleRetry=()=>{
        setInputValues([...Array(length).fill('')])
        handleRequestOTP();
        resetTimer();
    }
    const handleSubmit = () => {
        handleConfirm(inputValues.join(''));
    }
    return <div
        className="w-11/12 md:w-6/12 lg:w-5/12 xl:w-4/12 bg-white rounded-lg mt-5 p-5  mx-auto  flex flex-col items-center justify-center    ">
        <div className="flex justify-between w-full items-center ">
            {hasBack ? <AiOutlineArrowRight onClick={onBack} className="text-2xl" /> : <div/>}
            <div className=" bg-gray-100 p-3 flex  justify-center items-center rounded-full">
                <FaSms className="text-green-500 text-3xl"/>
            </div>
            <div/>
        </div>

        <h1 className="text-center font-bold mt-4 ">{title}</h1>
        <p className="text-sm text-center ">{description}</p>
        <div dir="ltr" style={{gridTemplateColumns: `repeat(${length}, minmax(0, 1fr))`}} className="grid mt-4 gap-1 ">
            {inputValues.map((value, index) => (
                <input
                    key={index}
                    ref={ref => inputRefs.current.push(ref)}
                    className={`p-3 rounded-t-lg text-center focus:outline-none border-b-2  bg-gray-50 ${inputValues[index].length > 0 ? 'border-green-500' : 'border-gray-200'}`}
                    type="tel"
                    value={inputValues[index]}
                    maxLength={1}
                    onChange={(event) => handleChange(index, event)}
                    onKeyDown={(event) => handleKeyDown(index, event)}
                />
            ))}</div>
        {error && <p className="w-full p-2 text-sm text-red-500">{error}</p>}
        <div className="w-full grid grid-cols-2 mt-4 pt-4 border-t">
            <Button loading={retryLoading} disabled={!isComplete} onClick={handleRetry} theme="link" rounded="rounded-lg" className="text-sm">{(isComplete)? 'درخواست مجدد' :`زمان باقی مانده ${time}`}</Button>
            <Button loading={confirmLoading} disabled={disabled} onClick={handleSubmit} theme="green" rounded="rounded-lg"
                    className="text-sm">تایید</Button>
        </div>
    </div>
}
export default OTP;